@if (column().type == 'datetime' || column().type == 'date') {
  <span title="{{ dataItem() | dateTime: column() }}">
    {{ dataItem() | dateTime: column() | mask: column().mask }}
  </span>
}

@if (column().type == 'boolean') {
  <span>
    <input type="checkbox" [checked]="dataItem() | lookup: column()" disabled />
  </span>
}

@if (column().type == 'decimal') {
  <span title="{{ dataItem() | lookup: column() | number }}">
    {{ dataItem() | lookup: column() | number: getNumberFormat() | mask: column().mask }}
  </span>
}

@if (column().type == 'integer') {
  <span title="{{ dataItem() | lookup: column() | number }}">
    {{ dataItem() | lookup: column() | number: '1.0-0' | mask: column().mask }}
  </span>
}

@if (column().type == 'optionSet') {
  <span
    title="{{ dataItem() != null ? dataItem()[column().primaryField] : '' }}"
    [style]="{ 'background-color': (dataItem() | optionSetColor: column()) }">
    {{ dataItem() | optionSet: column() }}
  </span>
}

@if (column().type == 'time') {
  <span title="{{ dataItem() | time: column() }}">
    {{ dataItem() | time: column() | mask: column().mask  }}
  </span>
}

@if (column().type == 'hyperlink') {
  <span class="hyperlink-column" title="{{ (dataItem() | hyperlink: column()).url }}">
    @if (dataItem() | hyperlink: column(); as hyperlink) {
      <a
        [appHyperlink]="hyperlink.url"
        [linkBehavior]="column().linkBehavior">
        {{ hyperlink.placeholder }}
      </a>
    }
  </span>
}

@if (column().isClickable && (column().type == 'text' || column().type == 'guid' || column().type == null)) {
  <span
    class="lookup-column"
    title="{{ dataItem() | lookup: column() }}">
    <span class="lookup-text" (click)="emitCellClick($event)">
      {{ dataItem() | lookup: column() | mask: column().mask }}
    </span>
  </span>
}

@if (!column().isClickable && (column().type == 'text' || column().type == 'guid' || column().type == null)) {
  <span
    title="{{ dataItem() | lookup: column() }}">
    {{ dataItem() | lookup: column() | mask: column().mask }}
  </span>
}

@if (column().type == 'progress' && !column().isOptionSet) {
  <span title="{{ dataItem() | lookup: column() }}">
    <app-progress-bar [min]="column().progressMinValue"
      [max]="column().progressMaxValue"
    [value]="+(dataItem() | lookup: column())" />
  </span>
}

@if (column().type == 'progress' && column().isOptionSet) {
  <span title="{{ dataItem() | lookup: column() }}">
    <app-optionset-progress-bar [optionSet]="column().optionSet"
      [min]="column().progressMinValue"
      [max]="column().progressMaxValue"
      [value]="dataItem() | lookup: column()" />
  </span>
}

@if (column().type == 'rating' && !column().isOptionSet) {
  <span title="{{ dataItem() | lookup: column() }}">
    <app-rating [value]="+(dataItem() | lookup: column())" [stars]="column() | ratingOptions" />
  </span>
}

@if (column().type == 'rating' && column().isOptionSet) {
  <span title="{{ dataItem() | optionSetValue: column() }}">
    <app-rating [value]="dataItem() | optionSetValue: column()" [stars]="column() | ratingOptions" />
  </span>
}

@if (column().type == 'icon') {
  <span title="{{dataItem() | iconTitle: column() }}">
    <app-img-icon [url]="dataItem() | iconUrl: column()"
      [iconMode]="column().iconMode"
      [icon]="dataItem() | icon: column()"
      [size]="column().width ? 'custom' : 'md'"
      [style]="{ 'align-items': column().alignItems,  'justify-content': column().align }" />
  </span>
}

@if (!column().isClickable && column().type == 'combinedTexts') {
  <span [title]="dataItem() | combinedTexts: column()">
    {{ dataItem() | combinedTexts: column() }}
  </span>
}

@if (column().isClickable && column().type == 'combinedTexts') {
  <span
    [title]="dataItem() | combinedTexts: column()"
    class="lookup-column">
    <span class="lookup-text" (click)="emitCellClick($event, column().primaryField)">
      {{ dataItem() | lookup: column():column().primaryField }}
    </span>
    @if ((dataItem() | lookup: column():column().primaryField) && (dataItem() | lookup: column():column().secondaryField)) {
      <span>
        {{ column().combinedTextsSeparator ?? ', ' }}
      </span>
    }
    <span class="lookup-text" (click)="emitCellClick($event, column().secondaryField)">
      {{ dataItem() | lookup: column():column().secondaryField }}
    </span>
  </span>
}

@if (column().type == 'process') {
  <span title="{{ dataItem() != null ? dataItem()[column().primaryField] : '' }}">
    <engine-process-grid-cell [stateId]="dataItem() != null ? dataItem()[column().primaryField] : null"
      [attributeName]="column().primaryField"
    [recordId]="dataItem() != null ? dataItem()['Id'] : null" />
  </span>
}
